
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/tickets/[slug]/[region]",
      function () {
        return require("private-next-pages/[locale]/tickets/[slug]/[region]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/tickets/[slug]/[region]"])
      });
    }
  